import { Box, Button, HStack, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import CenterPage from 'shared/misc/components/CenterPage';
import PerfImage from 'shared/misc/components/util/PerfImage';
import { USER_SIGN_UP_STEP } from 'shared/data/user';
import { createFileRoute } from '@tanstack/react-router';
import { useRouter } from '@tanstack/react-router';
export const Route = createFileRoute('/verify-complete/')({
  component: VerifyCompletePage,
});

function VerifyCompletePage() {
  const router = useRouter();

  return (
    <>
      <div className="min-h-screen flex items-center justify-center">
        <div className="m-[10px] sm:m-[100px] border-[1px] border-dashed border-brand-main p-[48px] bg-background">
          <div className="space-y-6 w-full flex flex-col items-center justify-center max-w-[400px]">
            <PerfImage
              src="https://files.pi.fyi/blue-star.png"
              alt="star-blue"
              width="50"
              height="50"
            />
            <p className="typography-heading-sm text-brand-main">Email verified.</p>
            <div className="space-x-3">
              <Button
                variant="primary"
                onClick={() => {
                  router.navigate({ to: '/' });
                }}
              >
                Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
